/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_UntitledInputs */

const zh_course_untitled = /** @type {(inputs: Course_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未命名课程`)
};

const en_course_untitled = /** @type {(inputs: Course_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled Course`)
};

const es_course_untitled = /** @type {(inputs: Course_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curso sin título`)
};

/**
* | output |
* | --- |
* | "Untitled Course" |
*
* @param {Course_UntitledInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const course_untitled = /** @type {((inputs?: Course_UntitledInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_UntitledInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_untitled(inputs)
	if (locale === "en") return en_course_untitled(inputs)
	return es_course_untitled(inputs)
});